<template>
	<modal
		:loading="loading"
		loading-message="Please wait..."
		@cancel="$emit('cancel')"
		size="narrow"
		target-class="registry-modal"
	>
		<img 
			class="x" 
			src="/assets/images/icons/remove.svg" 
			@click="$emit('cancel')" 
			@keydown.enter="$emit('cancel')" 
			aria-label="Close Button" 
			tabindex="0" 
			role="button" 
		/>
		<div>			
			<div v-if="!addedRegistry && firstList" class="form-group blain-form">				
				<div class="list-card">
					<input
						type="checkbox"
						name="checkbox"
						id="registry-checkbox"
						v-model="addedFromCheckbox"
						:value="firstList.ID"
						@change="checkboxAdd"
						v-focus
					/>
					<label for="registry-checkbox">
						<visually-hidden>
							Use "{{ formatListTitle(firstList) }}"?
							Alternatively, select a different list/registry in the select list below
						</visually-hidden>					
					</label>
					<img class="list-icon" :src="formatIconSrc(firstList)" :style="formatBackgroundStyle(firstList)" alt="" />
					<div class="lc-details">
						<h3>{{ formatListTitle(firstList) }}</h3>
						<p>{{ firstList.ListTypeString }}</p>
					</div>
				</div>
				<div class="or">
					<p>OR</p>
				</div>
				<visually-hidden tag="label" for="registry-select">Select a registry</visually-hidden>
				<select				
					id="registry-select"
					v-model="selectedRegistryID"
					class="form-control"
					name="listID"
					@change="updateSelect"
				>
					<option disabled :value="0">
						Select Registry or List
					</option>					
					<option					
						v-for="item in registryList"
						:key="item.ID"
						:value="item.ID"
					>
						{{ formatListOption(item) }}
					</option>
					<option value="create">
						Create New Registry Or List
					</option>					
				</select>
				<div class="sticky-footer">
					<button
						class="grey-btn"
						@click.stop="$emit('cancel')"
					>
						Cancel
					</button>		
					<button
						class="red-btn"						
						@click.stop="$emit('add-to-registry', selectedRegistryID)"
					>
						Add to Registry or List
					</button>		
				</div>
			</div>			
			<div v-else-if="addedRegistry" id="addedToRegistry" class="thank-you">
				<h2>
					Thank you!
				</h2>
				<p class="subheader text-center">
					This item has been added to your list
				</p>
				<div class="flex">
					<img 
						:class="addedRegistry.ListType === 7 ? 'list-icon baby' : 'list-icon'" 
						aria-hidden="true"
						:src="formatIconSrc(addedRegistry)" 
						:style="formatBackgroundStyle(addedRegistry)" 
					/>
					<div class="lc-details">
						<h3>{{ formatListTitle(addedRegistry) }}</h3>
						<p>{{ addedRegistry.ListTypeString }}</p>
					</div>
				</div>
				<div class="divider"></div>
				<button class="blue-btn" @click="$emit('cancel')">
					Continue Shopping
				</button>
				<a
					:href="`/gift-registry/edit/${selectedRegistryID}`"
					class="icon-btn view-registry"
				>
					<img class="reg-icon" src="/assets/images/icons/reglists.svg" aria-hidden="true" />
					View List/Registry
				</a>
			</div>
		</div>		
	</modal>
</template>

<script>
import focus from '../directives/focus';
import Modal from './Modal.vue';
import VisuallyHidden from './VisuallyHidden.vue';
export default {
	name: 'RegistryModal',
	props: {
		addedRegistry: Object,
		loading: Boolean,
		registryList: Array,
	},
	components: { 
		Modal,
		VisuallyHidden,
	},
	directives: {
		'focus': focus
	},
	computed: {
		firstList() {
			if (!this.registryList || !this.registryList.length) return null;						
			return this.registryList[0];				
		}
	},
	data() {
		return {
			selectedRegistryID: 0,
			addedFromCheckbox: true,
			selectedList: null
		};
	},		
	methods: {
		checkboxAdd(e) {
			if (!e.target.checked) {
				this.selectedRegistryID = 0;
				this.addedFromCheckbox = false;
			} else {
				this.selectedRegistryID = e.target.value;
				this.addedFromCheckbox = true;
			}
		},
		updateSelect(e) {
			if (e.target.value === 'create') {
				window.location.href = '/gift-registry/create';
			}
			this.addedFromCheckbox = false;
		},
		formatListOption(list) {
			let listTitle = '';
			let listSubtitle = '';				
			if (list.ListTitle) {
					 listTitle = list.ListTitle;
			} else {
				listTitle = list.ListTypeString;
			}

			if (!!list.EventDateString) {
				listSubtitle = ` | ${list.EventDateString}`;					
			} else {
				listSubtitle = ` | ${list.ListTypeString}`;
			}							

			return listTitle + listSubtitle;
		},
		formatListTitle(list) {
			if (list.ListTitle) { 
				return list.ListTitle;
			} else if (list.FirstName && list.lastName) {
				return `${list.FirstName} ${list.LastName}'s ${list.ListTypeString}`;
			} else {
				return list.ListTypeString;
			}					
		},
		formatIconSrc(list) {
			let src = '';				
			if (list.ListType === 2) {
				src = 'listShopping.svg';
			} else if (list.ListType === 3) {
				src = 'listWed.svg';
			} else if (list.ListType === 4 || list.ListType === 5) {
				src = 'listWish.svg';
			} else if (list.ListType === 7) {
				src = 'listBaby.svg';
			} else {
				src = 'listCustom.svg';
			}
			return '/assets/images/registry/' + src;
		},
		formatBackgroundStyle(list) {
			let color = '';				
			if (list.ListType === 2) {
				color = '#F5F1F8';
			} else if (list.ListType === 3) {
				color = '#EDF7F1';
			} else if (list.ListType === 4 || list.ListType === 5) {
				color = '#FEFAE3';
			} else if (list.ListType === 7) {
				color = '#FFF2EB';
			} else {
				color = '#ECFBF9';
			}
			return `background-color: ${color}`;
		}
	},
	watch: {
		firstList(newList) {
			if (newList) {
				if (this.selectedRegistryID === newList.ID) return;
				this.selectedRegistryID = newList.ID;
			}
		}
	},
};
</script>

<style lang="less">		
	.registry-modal {
		.blain-modal-content {			
			border: none;
			width: 700px;
			height: 440px;

			h3, p, h2 {
				margin-bottom: 0;
			}			

			.close-btn {
				display: none;
			}

			.x {
				height: 20px;
				width: 20px;
				margin-left: auto;
				display: block;
				margin-top: -5px;
				margin-right: -5px;
				cursor: pointer;
			}

			.grey-btn {
				border: 3px solid #C3C3C3;
				border-radius: 6px;
				background-color: #EEEEEE;
				color: #044A76;
				font-size: 18px;
				font-weight: bold;
				width: 190px;
				padding: 10px 0;
			}

			.red-btn {
				border-radius: 6px;
				font-weight: normal;
				width: 220px;
				padding: 12px 0;
				margin: 0 30px 0 20px;
			}

			.list-card {
				display: flex;
				border: 3px solid #F4F4F4;				
				margin: 40px 0 40px;
				padding: 20px;
			}
			.list-icon {
				height: 75px;
				width: 75px;
				border-radius: 50px;				
			}

			.baby {
					padding: 6px;
			}

			.lc-details {
				margin-left: 20px;
				display: flex;
				flex-direction: column;
				justify-content: center;					

				h3 {
					color: #044A76;
				}

				p {
					color: #666;
				}
			}
			.or {
				display: flex;
				justify-content: center;
				border-top: 2px solid #BCBCBC;

				p {
					background-color: #FFF;
					border-radius: 50px;
					display: block;
					padding: 10px;
					margin-top: -20px;
				}
			}
			.sticky-footer {
				display: flex;
				justify-content: flex-end;
				align-items: center;
				background-color: #EEEEEE;				
				height: 90px;
				position: absolute;
				bottom: 0;
				left: 0;
				right: 0;
				
			}
		}
		.thank-you {
			display: flex;
			flex-direction: column;
			align-items: center;
			h2 {
				font-size: 32px;
				margin: 4px 0 14px;
			}
			.subheader {
				margin-bottom: 30px !important;
				font-size: 20px;
				color: #4A4A4A;
				font-family: 'Roboto', sans-serif;
			}
			.divider {
				margin: 40px 0;
				background-color: #B7B7B7;
				height: 1.5px;
				width: 97%;
			}
			.blue-btn {
				font-size: 15px;
				width: 490px;
				border-radius: 6px;
				padding: 12px 0;
				margin-bottom: 16px;
			}
			.icon-btn {
				font-family: 'Roboto', sans-serif !important;
				width: 490px;
				text-decoration: none;
				display: flex;
				justify-content: center;
				align-items: center;
				padding: 6px;
				border: 2px solid #CCCCCC;
				border-radius: 6px;
				font-weight: bold;
				font-size: 15px;
				.reg-icon {
					height: 26px;
					width: 26px;
					margin-right: 6px;
				}
			}
		}
		@media screen and (max-width: 565px) {		
			.thank-you {
				.subheader {
					font-size: 18px;
				}
				.blue-btn {
					width: 98%;
				}
				.icon-btn {
					width: 98%;
				}
			}

		}
		@media screen and (max-width: 540px) {
			.list-icon {
				height: 50px !important;
				width: 50px !important;
			}
			.list-card {
				label[for=registry-checkbox] {
					padding-right: 10px;
				}
				
				p {
					font-size: 14px;
				}
			}
			.sticky-footer {
				justify-content: space-around !important;

				.grey-btn {
					width: 30%;
				}

				.red-btn {
					width: 60%;
					margin: 0;
				}
			}
		}
		@media screen and (max-width: 365px) {
			.sticky-footer {
				justify-content: space-around !important;

				.grey-btn {
					font-size: 14px;
				}

				.red-btn {
					font-size: 14px;
				}
			}
		}		
	}		
</style>